import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SalesFilterState } from "app/types/service-types/SalesTypes";
import DateUtils from "app/utils/DateUtils";

const todayIso = DateUtils.convertDateToIso(new Date()); // YYYY-MM-DD

const initialState: SalesFilterState = {
  fromDate: todayIso,
  toDate: todayIso,
  isPaid: true,
  // isRefund: true,
  source: "BMT_NETWORK",
  sort: "createdDate,desc",
};

const filterSalesSlice = createSlice({
  name: "sales/filter",
  initialState,
  reducers: {
    setSalesFilters(state, action: PayloadAction<Partial<SalesFilterState>>) {
      return { ...state, ...action.payload };
    },
    clearSalesFilters() {
      return initialState;
    },
  },
});

export const { setSalesFilters, clearSalesFilters } = filterSalesSlice.actions;
export default filterSalesSlice.reducer;
